<template>
    <a
        :href="href"
        :target="external ? '_blank' : null"
        :rel="external ? 'noopener noreferrer' : null"
        class="search-hit"
        @click="$emit('navigate')">
        <!-- The record's type, as the red label. On architecture.org this reads
             "Tour"/"Building"; once OHC records are indexed it carries
             "Open House Chicago - Sites" / "- Neighborhoods" per the ticket. -->
        <span v-if="hit.model" class="search-hit-label">{{ hit.model }}</span>
        <h3 v-if="title" class="search-hit-title">{{ title }}</h3>
        <p v-if="description" class="search-hit-description">{{ description }}</p>
    </a>
</template>

<script setup>
    import { hitTitle, hitDescription, resolveHitHref } from '@/composables/useSiteSearch';

    const props = defineProps({
        hit: { type: Object, required: true },
    });

    defineEmits(['navigate']);

    const title = computed(() => hitTitle(props.hit));
    const description = computed(() => hitDescription(props.hit));

    // architecture.org results open in a new window; OHC's own records (once
    // indexed) stay in-app. See resolveHitHref().
    const config = useRuntimeConfig().public;
    const resolved = computed(() => resolveHitHref(props.hit?.url, String(config.clientFrontend || '')));
    const href = computed(() => resolved.value.href || '#');
    const external = computed(() => resolved.value.external);
</script>

<style lang="scss" scoped>
    .search-hit {
        display: block;
        padding: 16px 0;
        border-bottom: 1px solid $gray-light-2;
        text-decoration: none;
        color: inherit;

        &:hover .search-hit-title,
        &:focus-visible .search-hit-title {
            text-decoration: underline;
        }
    }

    .search-hit-label {
        display: inline-block;
        margin-bottom: 6px;
        color: $red;
        font-family: $body;
        font-size: 12px;
        font-weight: $heavy;
        letter-spacing: 0.72px;
        text-transform: uppercase;
    }

    .search-hit-title {
        margin: 0 0 4px;
        font-family: $title;
        font-size: 18px;
        line-height: 1.2;
    }

    .search-hit-description {
        margin: 0;
        font-family: $body;
        font-size: 14px;
        line-height: 1.4;
        color: $gray-dark;
    }
</style>
